import { Skeleton, TableCell, TableRow } from '@mui/material'

const PurchaseOrdersTableSkeletons = ({ rows, header = false, columns = 5 }) => {
  return [...Array(rows)].map((row, index) => (
    <TableRow key={index}>
      <TableCell sx={{ p: 1, borderBottom: header ? 1 : 0 }} component="th" scope="row">
        <Skeleton animation="wave" variant="text" />
      </TableCell>
      {[...Array(columns - 1)].map((i, index) => (
        <TableCell key={index} sx={{ p: 1, borderBottom: header ? 1 : 0 }}>
          <Skeleton fontSize={header ? '1.2em' : '.9em'} animation="wave" variant="text" />
        </TableCell>
      ))}
    </TableRow>
  ))
}

export default PurchaseOrdersTableSkeletons
